import React, { ReactNode } from 'react';

import cx from 'clsx';

import styles from './Label.module.scss';

type LabelProps = {
  label?: ReactNode;
  htmlFor: string;
  labelClassName?: string;
  labelWrapperClassName?: string;
};

export const Label = ({ label, htmlFor, labelClassName, labelWrapperClassName }: LabelProps) =>
  label ? (
    <div className={cx(styles['label-wrapper'], labelWrapperClassName)}>
      <label htmlFor={htmlFor} className={cx(styles.label, labelClassName)}>
        {label}
      </label>
    </div>
  ) : null;
